
export const styleList =[
  'mathbf', 'mathit', 'mathsf', 'mathtt',
  'mathnormal', 'mathcal', 'mathscr', 'mathfrak','mathbb'
]
